<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="status" slot-scope="params">
        <span v-if="params.params.active == 0" style="color:red">未处理</span>
        <span v-if="params.params.active == 1">已处理</span>
      </template>
    </Table>

    <FormDialog class="formDialog" ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform"
      :rules="mrules" :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onMadolFormChange"
      @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

const activeOptions = [
  { label: '未处理', value: 0 },
  { label: '已处理', value: 1 },
]

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'violation',
      getListUrl: 'getViolationDetail',
      formInline: {},
      formCtrl: [
        {
          label: "车牌号：",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "处理状态：",
          keyName: "active",
          placeholder: "请选择处理状态",
          type: "select",
          options: activeOptions,
        },
        {
          label: "时间选择：",
          keyName: "created_at",
          placeholder: "选择日期",
          type: "month",
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "created_at", label: "违章时间" },
        { prop: "address", label: "违章地点" },
        { prop: "content", label: "违章行为" },
        { prop: "kpoints", label: "扣分" },
        { prop: "fine", label: "罚款" },
        { prop: "active", label: "处理状态", slot: "status" },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: (params) => {
            this.title = "违章详情";
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = params[key];
            });
            this.mform['id'] = params['id'];
            this.modalSubmitUrl = 'updateViolationDetail';
            this.showDialog();
          },
        },
      ],
      baseParams: ['license'],
      getOptionUrl: 'getcarlist',
      viewMode: false,
      title: '违章详情',
      mform: {},
      mrules: {},
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请选择车牌号",
          type: "select",
          options: [],
        },
        {
          label: "司机",
          keyName: "driver",
          err: "请选择司机姓名",
          type: "select",
          options: [],
        },
        {
          label: "违章时间",
          keyName: "created_at",
          err: "请选择违章时间",
          type: "date",
          options: [],
        },
        {
          label: "违章地点",
          keyName: "address",
          err: "请填写违章地点",
          type: "text",
        },
        {
          label: "违章行为",
          keyName: "content",
          err: "请填写违章行为",
          type: "text",
        },
        {
          label: "扣分",
          keyName: "kpoints",
          err: "请填写扣分",
          type: "text",
        },
        {
          label: "罚款",
          keyName: "fine",
          err: "请填写罚款",
          type: "text",
        },
        {
          label: "处理状态",
          keyName: "active",
          err: "请选择处理状态",
          type: "select",
          options: activeOptions,
        },
      ],
      relation: [],
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          params[key] = value;
        }
      }

      const opt = this.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'violation',
      }
    },

    setQuery() {
      const { license } = this.$route.query
      this.formInline.license = license
      // console.log(this.formInline)
      this.getList()
    },
    setOptions({ data, driver_list }) {
      // 储存车与司机对应关系
      this.relation = [...data]
      this.mformCtrl.map(v => {
        if (v.keyName == 'license') {
          v.options = data.map(val => {
            return {
              label: val.license,
              value: val.license,
            }
          })
        } else if (v.keyName == 'driver') {
          v.options = driver_list.map(val => {
            return {
              label: val,
              value: val,
            }
          })
        }
      })
    },
    addItem() {
      //   this.$router.push(`/vehicle/expatriatedetail`);
      this.title = '违章详情'
      // 给需要设置的数据赋予初始值
      this.mform = {
        license: undefined,
        driver: undefined,
      };
      this.modalSubmitUrl = 'setViolationStatistics';
      this.showDialog();
    },
    onMadolFormChange({ key, value }) {
      if (key === 'license') {
        // console.log(key, value)
        this.relation.map(v => {
          if (v[key] === value) {
            console.log({ ...v })
            this.mform['driver'] = v['driver']
            console.log({ ...this.mform })
            this.$forceUpdate()
          }
        })
      }
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setQuery()
    },
  },
  mounted() {
    this.setQuery()
    this.getOptions();
  },
};
</script>

<style lang="less" scoped>
.formDialog {

  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
}
</style>
